module.exports = __webpack_public_path__ + "static/media/intranet_logo.9ac52c76.png";